module.exports = __webpack_public_path__ + "img/dzjy1.40d60b45.jpg";